/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImageTypeEnum {
    TEAM_THUMB = 'team_thumb',
    TEAM_PHOTO = 'team_photo',
    SPONSOR_LOGO = 'sponsor_logo',
    BLOG_PHOTO = 'blog_photo',
    AD_MOBILE_SMALL = 'ad_mobile_small',
    AD_MOBILE_MEDIUM = 'ad_mobile_medium',
    AD_DESKTOP = 'ad_desktop',
    PROFILE_PICTURE = 'profile_picture',
    BADGE = 'badge',
    AD_SHARES = 'ad_shares',
}
